/**
 * 4.3.3 walkthrough slides.
 *
 * Each slide:
 *   {
 *     image:          public-path string (e.g. '/walkthroughs/4.3.3/foo.png'),
 *     title:          short heading,
 *     body:           one or two sentences describing the change,
 *     minRoleWeight?: integer — only users with role_weight >= this see the slide
 *                     (matches hasMinRole gating; omit for "visible to everyone")
 *   }
 *
 * Drop walkthrough images under public/walkthroughs/{version}/.
 */
export default [
  {
    image: '/walkthroughs/4.3.3/slide1.png',
    title: '5.0 Alerts Enhanced',
    body: 'Our new portal 5.0 alerts page now supports flagging high priority alerts that always appear at the top and are adorned with a banner indicating such. Alerts with multiple residents now display all listed residents.',
    minRoleName: "PalCare Employees Only",
    minRoleWeight: 80
  },{
    image: '/walkthroughs/4.3.3/slide2.png',
    title: 'Alert Enhancements also for Mobile Mode',
    body: '5.0 Mobile mode also supports the high priority and multi resident display. Also when AFR workflow is enabled in portal resident selection for multiple residents has been added.',
    minRoleName: "PalCare Employees Only",
    minRoleWeight: 80
  },{
    image: '/walkthroughs/4.3.3/slide3.png',
    title: 'Call Logs Report for SIP Services',
    body: 'For customers utilizing the Grandstream SIP calling system, a new report to view historical calls has been added',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10
  },{
    image: '/walkthroughs/4.3.3/slide4.png',
    title: 'Call logs show on event details',
    body: 'Any SIP calls performed during a live event are logged and viewable within event details.',
    minRoleName: "All Administrators, Corporate",
    minRoleWeight: 10
  },{
    image: '/walkthroughs/4.3.3/slide5.png',
    title: 'A quicker view into Careflow escalations',
    body: 'Careflow escalations now have a quick hover to quickly see output settings for faster analysis',
    minRoleName: "Corporate Only",
    minRoleWeight: 30
  },{
    image: '/walkthroughs/4.3.3/slide6.png',
    title: 'Careflow escalations enhanced add workflow',
    body: 'New Careflow escalations being setup can now be fully configured through one step',
    minRoleName: "Corporate Only",
    minRoleWeight: 30
  },{
    image: '/walkthroughs/4.3.3/slide7.png',
    title: 'Full local server database editing',
    body: 'Added functionality to be able to edit any item in the local servers database',
    minRoleName: "PalCare Employees Only",
    minRoleWeight: 80
  },
];